import React from 'react';
import styled from 'styled-components';
import { PriceTestProductSummary } from '@/features/details/price-test-reports/api';
import { HSpace } from '@/components/spacing';
import { format } from '@/features/details/price-test-reports/shared';

export function DeskTileHeader({
  p: { image, title, totalItemsSoled, totalRevenue },
}: {
  p: PriceTestProductSummary;
}) {
  return (
    <Row>
      <Title>
        <img src={image} alt={title} />
        <HSpace />
        <ProductTitle>{title || ``}</ProductTitle>
      </Title>
      <ProductDetails>
        <span>Units Sold: {format(totalItemsSoled || 0)}</span>
        <HSpace value={6} />
        <TotalSpan>Total: ${format(totalRevenue || 0)}</TotalSpan>
      </ProductDetails>
    </Row>
  );
}
const TotalSpan = styled.span`
  margin-right: 3rem;
  @media (max-width: 768px) {
    margin-right: 0;
  }
`;
const ProductDetails = styled.div`
  display: flex;

  span {
    @media (max-width: 768px) {
      font-size: 1.2rem;
      text-align: end;
    }
    text-align: center;

    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: -0.22px;
    color: #121920;
    font-family: Inter, serif;
    font-size: 1.4rem;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  font-family: Inter, serif;
  font-size: 1.3rem;
  font-weight: 600;

  img {
    border-radius: 8px;
    height: 100px;
  }
`;
const ProductTitle = styled.span`
  margin-left: 1rem;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 50px;
  @media (max-width: 768px) {
    margin-left: 0;
    max-width: 150px;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2.2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid rgba(216, 216, 216, 0.63);
`;
